import React from 'react';
import css from './OfferModal.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { Modal } from '../../components';
import OfferForm from './OfferForm/OfferForm';
import { FormattedMessage, useIntl } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';

import {
  transitionErrorSelector,
  transitionInProgress,
} from '../TransactionPage/TransactionPage.duck';
import {
  sendOfferInProgressSelector,
  sendOfferErrorSelector,
} from '../ListingPage/ListingPage.duck';
import Icons from '../../components/Icons/Icons';

const OfferModal = ({
  isOpen,
  onClose,
  authorDisplayName,
  listing,
  isTransactionPage = false,
  onSubmit,
  title,
  initialValues,
}) => {
  const intl = useIntl();
  const config = useConfiguration();
  const dispatch = useDispatch();

  const submitInProgress = useSelector(sendOfferInProgressSelector);
  const sendOfferError = useSelector(sendOfferErrorSelector);

  const transitionInProgressState = useSelector(transitionInProgress);
  const transitionErrorState = useSelector(transitionErrorSelector);

  const inProgress = isTransactionPage ? transitionInProgressState : submitInProgress;
  const error = isTransactionPage ? transitionErrorState : sendOfferError;

  const publicData = listing?.attributes?.publicData || {};
  const unitType = publicData?.unitType;
  const isItemUnitType = unitType === 'item';
  const moqRaw = publicData?.moq;
  const moq = Number.isInteger(moqRaw) ? moqRaw : Number.parseInt(moqRaw, 10);
  const defaultQuantity = Number.isInteger(moq) && moq > 0 ? moq : 1;
  const initialValuesMaybe =
    initialValues || (isItemUnitType ? { quantity: defaultQuantity } : undefined);

  return (
    <Modal
      id="OfferModal"
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={(componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling))
      }
      modalTitle=<FormattedMessage
        id="OfferForm.heading"
        values={{ listingTitle: title, authorDisplayName }}
      />
      modalIcon=<Icons name="tag" />
    >
      <div className={css.modalContent}>
        <OfferForm
          onSubmit={onSubmit}
          intl={intl}
          inProgress={inProgress}
          authorDisplayName={authorDisplayName}
          config={config}
          sendOfferError={error}
          listingTitle={title}
          listing={listing}
          initialValues={initialValuesMaybe}
        />
      </div>
    </Modal>
  );
};

export default OfferModal;
